import  {apis,request,methods} from "../request";
export const httpProductDetails = (id)=>{
    return request(methods.get,apis.productDetails+id)
 }